// extracted by mini-css-extract-plugin
var _1 = "ReportMainBody__allLevels--VB7Cq";
var _2 = "ReportMainBody__arrowHead--Xnmar";
var _3 = "ReportMainBody__arrowHeadUp--UKhgM";
var _4 = "ReportMainBody__arrowLine--uUMnE";
var _5 = "ReportMainBody__arrowTail--Yz1jV";
var _6 = "ReportMainBody__attemptNum--XKtkK";
var _7 = "ReportMainBody__attemptNums--ecgoc";
var _8 = "ReportMainBody__attemptsOuter--tZW2Z ReportMainBody__forGraphics--vDjxS";
var _9 = "ReportMainBody__backdrop--OPmh8";
var _a = "ReportMainBody__best--o7TQC";
var _b = "ReportMainBody__bestCircle--so3kF ReportMainBody__sortOffset--bGo9j";
var _c = "ReportMainBody__bestTrophy--SVz33";
var _d = "ReportMainBody__blockBars--db37b";
var _e = "ReportMainBody__blocksModal--K4wLA";
var _f = "ReportMainBody__blocksModalBreak--tgOVx";
var _10 = "ReportMainBody__blocksModalHeader--ZbYcc";
var _11 = "ReportMainBody__blocksModalMessage--MVbbn";
var _12 = "ReportMainBody__blocksModalStudentName--sc1r8";
var _13 = "ReportMainBody__blocksModalStudentsList--lYX9c";
var _14 = "ReportMainBody__blocksModalText--OqsR8";
var _15 = "ReportMainBody__body--jMWke";
var _16 = "ReportMainBody__center--kYd74";
var _17 = "ReportMainBody__centerHeader--vPr3U";
var _18 = "ReportMainBody__circle--M9Ska";
var _19 = "ReportMainBody__circleClick--Bd7UZ ReportMainBody__circle--M9Ska";
var _1a = "ReportMainBody__circleHeader--zZDfG";
var _1b = "ReportMainBody__circleOuter--CWDJ2";
var _1c = "ReportMainBody__circleWrap--ylt2J";
var _1d = "ReportMainBody__circleWrapLarge--u09hH ReportMainBody__circleWrap--ylt2J";
var _1e = "ReportMainBody__circlesOuter--IBXnt";
var _1f = "ReportMainBody__circlesOuterShort--tMZl_ ReportMainBody__circlesOuter--IBXnt";
var _20 = "ReportMainBody__cooldownNote--B_x0B";
var _21 = "ReportMainBody__crumbRow--o16I2";
var _22 = "ReportMainBody__dot--Mxiiv";
var _23 = "ReportMainBody__end--fK5yk";
var _24 = "ReportMainBody__forClass--fnSu8";
var _25 = "ReportMainBody__forGraphics--vDjxS";
var _26 = "ReportMainBody__forParent--RelrJ";
var _27 = "ReportMainBody__gradeIcon--OPQ_9";
var _28 = "ReportMainBody__gradeLogo--_0h_I";
var _29 = "ReportMainBody__graphBar--XIaoz";
var _2a = "ReportMainBody__graphBarFat--xjBDq ReportMainBody__graphBar--XIaoz";
var _2b = "ReportMainBody__graphBarTall--ueRGl ReportMainBody__graphBar--XIaoz";
var _2c = "ReportMainBody__graphHeader--d8EYU";
var _2d = "ReportMainBody__graphHorizOuter--MddXC";
var _2e = "ReportMainBody__graphOuter--JCgLv";
var _2f = "ReportMainBody__graphTallOuter--tMcZ5 ReportMainBody__forGraphics--vDjxS";
var _30 = "ReportMainBody__headerColFlex--bEtHt";
var _31 = "ReportMainBody__headerColLarge--UItlP";
var _32 = "ReportMainBody__headerColSmall--E9OAH";
var _33 = "ReportMainBody__iconHeader--fk8H1";
var _34 = "ReportMainBody__infoHeader--lF1EH";
var _35 = "ReportMainBody__infoIcon--xuLi4";
var _36 = "ReportMainBody__infoModal--YL2mA";
var _37 = "ReportMainBody__infoModalText--uELqk";
var _38 = "ReportMainBody__latestOuter--Ego1a ReportMainBody__forGraphics--vDjxS";
var _39 = "ReportMainBody__legend--hvsWf";
var _3a = "ReportMainBody__line--BdwJx";
var _3b = "ReportMainBody__link--eQ2e3 SchoolGeneral__link--tS8wu OfficeGeneral__inlineLink--J2Xk5 OfficeGeneral__inlineLinkBase--ofwQY OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _3c = "ReportMainBody__loading--mG49T SchoolGeneral__loading--lfV7U";
var _3d = "ReportMainBody__main--jpqQS";
var _3e = "ReportMainBody__mainContent--WBxUM";
var _3f = "ReportMainBody__modal--M9ofs OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _40 = "ReportMainBody__more--Kvcnp";
var _41 = "ReportMainBody__navRow--QVI4K";
var _42 = "ReportMainBody__printIcon--aItmC OfficeGeneral__baoFont--nS_70 CoreGeneral__baoFont--dcsOj";
var _43 = "ReportMainBody__printIconLong--crbGN ReportMainBody__printIcon--aItmC OfficeGeneral__baoFont--nS_70 CoreGeneral__baoFont--dcsOj";
var _44 = "ReportMainBody__printOption--YBNEW";
var _45 = "ReportMainBody__printOptions--jraHX OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _46 = "ReportMainBody__problemsOuter--f_vxW ReportMainBody__forGraphics--vDjxS";
var _47 = "ReportMainBody__puzzleIcon--T7nj_";
var _48 = "ReportMainBody__puzzleName--qBswJ ReportMainBody__link--eQ2e3 SchoolGeneral__link--tS8wu OfficeGeneral__inlineLink--J2Xk5 OfficeGeneral__inlineLinkBase--ofwQY OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _49 = "ReportMainBody__puzzleSvg--hTluy ReportMainBody__puzzleIcon--T7nj_";
var _4a = "ReportMainBody__sectionLock--hup5G";
var _4b = "ReportMainBody__set--Q375p";
var _4c = "ReportMainBody__singleStudent--YWkdz";
var _4d = "ReportMainBody__singleTrophy--jL3Z0";
var _4e = "ReportMainBody__sortOffset--bGo9j";
var _4f = "ReportMainBody__starTrophy--N59XT";
var _50 = "ReportMainBody__start--F63sF";
var _51 = "ReportMainBody__statHeader--ZrLt2";
var _52 = "ReportMainBody__statHeaderCenter--kHGkz";
var _53 = "ReportMainBody__statPC--d7Pjq";
var _54 = "ReportMainBody__statPlayed--xdmQ7";
var _55 = "ReportMainBody__statStar--d9HVn";
var _56 = "ReportMainBody__statTime--jUnZ_";
var _57 = "ReportMainBody__statTrophy--VY7kc";
var _58 = "ReportMainBody__studentToggle--YhO4L";
var _59 = "ReportMainBody__summaryBar--a1Cg_";
var _5a = "ReportMainBody__tableMobile--piR8D";
var _5b = "ReportMainBody__tbLeft--kVX8Q";
var _5c = "ReportMainBody__tbRight--orNUm";
var _5d = "ReportMainBody__test--Kbr5q";
var _5e = "ReportMainBody__testCol--z5yCC";
var _5f = "ReportMainBody__testLabel--b7ZBc";
var _60 = "ReportMainBody__testUnlockRow--pA9AC";
var _61 = "ReportMainBody__topSummary--n9qDS";
var _62 = "ReportMainBody__trialNum--Dk7D6";
var _63 = "ReportMainBody__trialNums--rrkQK";
var _64 = "ReportMainBody__trophyInline--Do8Gu";
var _65 = "ReportMainBody__trophyOuter--e472T";
export { _1 as "allLevels", _2 as "arrowHead", _3 as "arrowHeadUp", _4 as "arrowLine", _5 as "arrowTail", _6 as "attemptNum", _7 as "attemptNums", _8 as "attemptsOuter", _9 as "backdrop", _a as "best", _b as "bestCircle", _c as "bestTrophy", _d as "blockBars", _e as "blocksModal", _f as "blocksModalBreak", _10 as "blocksModalHeader", _11 as "blocksModalMessage", _12 as "blocksModalStudentName", _13 as "blocksModalStudentsList", _14 as "blocksModalText", _15 as "body", _16 as "center", _17 as "centerHeader", _18 as "circle", _19 as "circleClick", _1a as "circleHeader", _1b as "circleOuter", _1c as "circleWrap", _1d as "circleWrapLarge", _1e as "circlesOuter", _1f as "circlesOuterShort", _20 as "cooldownNote", _21 as "crumbRow", _22 as "dot", _23 as "end", _24 as "forClass", _25 as "forGraphics", _26 as "forParent", _27 as "gradeIcon", _28 as "gradeLogo", _29 as "graphBar", _2a as "graphBarFat", _2b as "graphBarTall", _2c as "graphHeader", _2d as "graphHorizOuter", _2e as "graphOuter", _2f as "graphTallOuter", _30 as "headerColFlex", _31 as "headerColLarge", _32 as "headerColSmall", _33 as "iconHeader", _34 as "infoHeader", _35 as "infoIcon", _36 as "infoModal", _37 as "infoModalText", _38 as "latestOuter", _39 as "legend", _3a as "line", _3b as "link", _3c as "loading", _3d as "main", _3e as "mainContent", _3f as "modal", _40 as "more", _41 as "navRow", _42 as "printIcon", _43 as "printIconLong", _44 as "printOption", _45 as "printOptions", _46 as "problemsOuter", _47 as "puzzleIcon", _48 as "puzzleName", _49 as "puzzleSvg", _4a as "sectionLock", _4b as "set", _4c as "singleStudent", _4d as "singleTrophy", _4e as "sortOffset", _4f as "starTrophy", _50 as "start", _51 as "statHeader", _52 as "statHeaderCenter", _53 as "statPC", _54 as "statPlayed", _55 as "statStar", _56 as "statTime", _57 as "statTrophy", _58 as "studentToggle", _59 as "summaryBar", _5a as "tableMobile", _5b as "tbLeft", _5c as "tbRight", _5d as "test", _5e as "testCol", _5f as "testLabel", _60 as "testUnlockRow", _61 as "topSummary", _62 as "trialNum", _63 as "trialNums", _64 as "trophyInline", _65 as "trophyOuter" }
